import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { getDbHeaders, SUPABASE_URL, supabaseClient } from '../db/client';

export function isNative() {
  return Capacitor.isNativePlatform();
}

// Call once after login. Requests permission, gets APNs token, saves to apns_tokens.
export async function registerNativePush({ airline }) {
  if (!isNative()) return;

  await PushNotifications.removeAllListeners();

  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== 'granted') return;

  // Wire up listeners before register() so the token event is never missed
  PushNotifications.addListener('registration', async (token) => {
    console.log('[nativePush] token received:', token.value);

    const { data: { session: supabaseSession }, error: sessionError } = await supabaseClient.auth.getSession();
    console.log('[nativePush] userId:', supabaseSession?.user?.id, 'sessionError:', sessionError?.message);
    const userId = supabaseSession?.user?.id;
    if (!userId) { console.error('[nativePush] no userId — aborting'); return; }

    const headers = await getDbHeaders({ 'Content-Type': 'application/json' });

    const delRes = await fetch(`${SUPABASE_URL}/rest/v1/apns_tokens?user_id=eq.${userId}`, { method: 'DELETE', headers });
    console.log('[nativePush] DELETE status:', delRes.status);

    const insRes = await fetch(`${SUPABASE_URL}/rest/v1/apns_tokens`, {
      method: 'POST',
      headers: { ...headers, 'Prefer': 'resolution=merge-duplicates,return=minimal' },
      body: JSON.stringify({ device_token: token.value.toLowerCase(), airline, user_id: userId }),
    });
    const insText = await insRes.text();
    console.log('[nativePush] INSERT status:', insRes.status, insText);
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('APNs registration error:', err.error);
  });

  // Foreground notifications — system handles badge + sound automatically;
  // wire this up if you want an in-app banner later
  PushNotifications.addListener('pushNotificationReceived', (_notification) => {});

  await PushNotifications.register();
}

export async function unregisterNativePush() {
  if (!isNative()) return;
  PushNotifications.removeAllListeners();

  const { data: { session: supabaseSession } } = await supabaseClient.auth.getSession();
  const userId = supabaseSession?.user?.id;
  if (!userId) return;

  const headers = await getDbHeaders();
  await fetch(
    `${SUPABASE_URL}/rest/v1/apns_tokens?user_id=eq.${userId}`,
    { method: 'DELETE', headers }
  );
}
